import { React, useState, useEffect} from "react";
import { Link } from "react-router-dom";
import { clearToken } from "../utils/auth";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import { getUserInfo } from "../utils/auth";

const Sidebar = () => {
  const navigate = useNavigate();
  const [role, setRole] = useState("");
  const [userEmail, setUserEmail] = useState("");

  const logout = () => {
    clearToken();
    navigate("/login");
  };

  const setUserDetails = () => {
    const userInfo = getUserInfo();
    const ENCRYPT_DECRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY;
    const bytes = CryptoJS.AES.decrypt(userInfo, ENCRYPT_DECRYPTION_KEY);
    const decryptedUserDetails = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    setRole(decryptedUserDetails.role);
    setUserEmail(decryptedUserDetails.email);
  };

  useEffect(() => {
    setUserDetails();
  }, []);

  return (
    <div className="sidebar border border-right col-md-3 col-lg-2 p-0 bg-body-tertiary">
      <div
        className="offcanvas-md offcanvas-end bg-body-tertiary"
        tabIndex="-1"
        id="sidebarMenu"
        aria-labelledby="sidebarMenuLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="sidebarMenuLabel">
            <Link to={`/dashboard`} className="btn btn-info card-link">
              Company name
            </Link>
          </h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            data-bs-target="#sidebarMenu"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body d-md-flex flex-column p-0 pt-lg-3 overflow-y-auto">
          <ul className="nav flex-column">
            <li className="nav-item">
              <Link
                to={`/dashboard`}
                className="nav-link d-flex align-items-center gap-2 active"
                aria-current="page"
              >
                <svg className="bi">
                  <use xlinkHref="#house-fill" />
                </svg>
                Dashboard
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to={`/communication`}
                className="nav-link d-flex align-items-center gap-2 active"
                aria-current="page"
              >
                <svg className="bi">
                  <use xlinkHref="#house-fill" />
                </svg>
                Communication
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to={`/templateSelection`}
                className="nav-link d-flex align-items-center gap-2 active"
                aria-current="page"
              >
                <svg className="bi">
                  <use xlinkHref="#house-fill" />
                </svg>
                Template Selection
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to={`/domainSearch`}
                className="nav-link d-flex align-items-center gap-2 active"
                aria-current="page"
              >
                <svg className="bi">
                  <use xlinkHref="#house-fill" />
                </svg>
                Your Website Domain
              </Link>
            </li>
            {role == "ROLE_SUPER_ADMIN" && (
              <>
                <li className="nav-item">
                  <Link
                    to={`/templateSelection`}
                    className="nav-link d-flex align-items-center gap-2 active"
                    aria-current="page"
                  >
                    <svg className="bi">
                      <use xlinkHref="#house-fill" />
                    </svg>
                    Template Selection
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to={`/templateList`}
                    className="nav-link d-flex align-items-center gap-2 active"
                    aria-current="page"
                  >
                    <svg className="bi">
                      <use xlinkHref="#house-fill" />
                    </svg>
                    Template List
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to={`/createTemplate`}
                    className="nav-link d-flex align-items-center gap-2 active"
                    aria-current="page"
                  >
                    <svg className="bi">
                      <use xlinkHref="#house-fill" />
                    </svg>
                    Create Template
                  </Link>
                </li>
              </>
            )}
          </ul>

          <hr className="my-3" />

          <ul className="nav flex-column mb-auto">
            <li className="nav-item">
              <a
                className="nav-link d-flex align-items-center gap-2"
                href="#"
                onClick={logout}
              >
                <svg className="bi">
                  <use xlinkHref="#door-closed" />
                </svg>
                Sign out
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
